import React from "react";
import cn from "classnames";
import InfoPage from ".";
import styles from "./WhyPostaway.module.sass";

const HowToUsePostaway = () => {
  const below = (
    <div className={styles.layoutContainer}>
      {/* Left Column */}
      <div className={styles.leftColumn}>
        {/* Creators Card */}
        <div className={cn(styles.card, styles.cardCreators)}>
          <h3 className={styles.cardTitle}>CREATORS</h3>
          <div className={styles.cardContent}>
            <p style={{color: 'white'}}>• Create a profile<br/>• Choose a membership level<br/>• Post an opportunity on the collab board<br/>• Search listings<br/>• Upload itineraries<br/>• Refer creators, hosts, and travelers</p>
          </div>
        </div>

        {/* Hosts Card */}
        <div className={cn(styles.card, styles.cardHosts)}>
          <h3 className={styles.cardTitle}>HOSTS</h3>
          <div className={styles.cardContent}>
            <p style={{color: 'white'}}>• Create a profile<br/>• Choose a membership level<br/>• Post an opportunity on the collab board<br/>• Search creators<br/>• Refer creators, hosts, and travelers</p>
          </div>
        </div>
      </div>

      {/* Right Column */}
      <div className={styles.rightColumn}>
        {/* Travelers Card */}
        <div className={cn(styles.card, styles.cardTravelers)}>
          <h3 className={styles.cardTitle}>TRAVELERS</h3>
          <div className={styles.cardContent}>
            <p>• Create a profile<br/>• Join Postaway<br/>• Search listings, creators, itineraries<br/>• Refer creators, hosts, and travelers</p>
          </div>
        </div>

        {/* Travelers Image */}
        <div className={styles.travelersImage}>
          <img
            src="/how-to (1).png"
            alt="How to use Postaway"
          />
        </div>

        {/* Travelers Image Caption */}
        <div style={{
          fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
          fontSize: 'clamp(10px, 3vw, 12px)',
          color: '#0f084b',
          opacity: .9,
          lineHeight: 1.35,
          textAlign: 'center',
          marginTop: -25
        }}>
          @katlynkahler x @theeverwoods
        </div>
      </div>
    </div>
  );

  return <InfoPage title="How to use Postaway" below={below} divider tallOverride={false} />;
};

export default HowToUsePostaway;


